import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { AuthService } from 'app/services/auth.service';
import { XlXuLySuCoService } from 'app/xu-ly/xl-xu-ly-su-co/xl-xu-ly-su-co.service';


var FileSaver = require('file-saver');

@Component({
    selector: 'xl-xu-ly-lich-su',
    templateUrl: 'xl-xu-ly-lich-su.component.html'
})
export class XLXuLyLichSuHomeComponent implements OnInit {
    @Input("lgModalHienThi") lgModalHienThi;
    @Input("Item") set _XL(val) {
        this.XL = val;        
        this.Load_DanhSachLichSuXuLy();        
    };

    constructor(
        private serviceXL:XlXuLySuCoService,
        private auth: AuthService
    ) { }

    DanhSachLS:any[] = [];
    DanhSachTT:any[]=[];
    XL:any={};
    status: boolean = false;
    message: string = "";
    ngOnInit() { }

    Load_DanhSachLichSuXuLy(){
        this.status=true;
        this.message="Đang tải dữ liệu ...";
        this.serviceXL.DanhSach_XuLyLichSu(this.XL).subscribe(
            resp=>{
                var dsa: any[] = [];  
                this.DanhSachLS = resp;              
                this.DanhSachLS.forEach((item,index)=>{                   
                    var it = {
                        ls: item,
                        ds: JSON.parse(item.dsfile)
                    }
                    dsa.push(it);
                })
                this.DanhSachLS = dsa;
                console.log(this.DanhSachLS);
                this.status=false;
            }
        )
    }
    Load_DanhSachTapTinXuLy(){
        this.serviceXL.DanhSach_TapTinXuLy(this.XL).subscribe(
            resp=>{
                this.DanhSachTT = resp;
                this.Load_DanhSachLichSuXuLy();
            }
        )
    }
    TaiFile(filename, op){
        filename = encodeURIComponent(filename);
        if(op == 0){
            this.TaiVe_TapTinYC(filename);
        }else{
            this.TaiVe_TapTin(filename);
        }
    }
    TaiVe_TapTinYC(filename) {       
        this.serviceXL.DownloadFileYeuCau(filename).subscribe(
          resp => {
            var blob = new Blob([resp], { type: "application/octet-stream" });
            FileSaver.saveAs(blob, filename);
          }
        );
      }
    TaiVe_TapTin(filename){
        let name = this.auth.encrypt(filename,'file');   
        this.serviceXL.DownloadFileLichSu(name).subscribe(
            resp => {
                var blob = new Blob([resp], { type: "application/octet-stream" });
                FileSaver.saveAs(blob, filename);
            }
        );
    }   
    XuatExcel() {  
        this.status=true;     
        this.message = "Đang tải dữ liệu ..."; 
        this.serviceXL.XuatExcel(this.XL.IdYeuCau).subscribe(
            resp => {
                this.status=false;
                var blob = new Blob([resp], { type: "application/octet-stream" });
                FileSaver.saveAs(blob, 'LichSuXuLyPA.xlsx');                
            }
        );
    }
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/home/xl-xu-ly-lich-su.component.ts